var map = {
	"./NIM_Web_Chatroom_v4.7.0": 94,
	"./NIM_Web_Chatroom_v4.7.0.js": 94,
	"./NIM_Web_NIM_v4.7.0": 95,
	"./NIM_Web_NIM_v4.7.0.js": 95,
	"./NIM_Web_Netcall_v4.7.0": 96,
	"./NIM_Web_Netcall_v4.7.0.js": 96,
	"./NIM_Web_SDK_v4.7.0": 97,
	"./NIM_Web_SDK_v4.7.0.js": 97,
	"./NIM_Web_WebRTC_v4.7.0": 98,
	"./NIM_Web_WebRTC_v4.7.0.js": 98
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;


//////////////////
// WEBPACK FOOTER
// ./src/sdk ^\.\/.*$
// module id = 93
// module chunks = 18 19